<section id="section-why-finzy" class="row">
  <div class="row">
    <h2 class="heading col-xs-10 col-xs-offset-1 center-align">Why finzy</h2>
  </div>

  <div class="row">
    <p class="subheading col-xs-10 col-xs-offset-1">Get a loan in a quick turn around time, at low interest rates and in a hassle free manner.</p>
  </div>

  <div class="row">
    <div class="col-xs-10 col-xs-offset-1">
      <div class="row">
        <div class="col-xs-12 col-md-4 col-lg-4 subsection">
          <img src="../../../../assets/images/why-finzy/quick-and-easy.svg"
               alt="Quick and easy to apply for loan"
               class="img-responsive icon">
          <p class="heading">Quick & Easy</p>
          <p class="description">A quick online loan application process allows loans to get funded in as less as 48
            hours. finzy facilitates execution of loan agreement at your doorstep.
          </p>
        </div>

        <div class="col-xs-12 col-md-4 col-lg-4 subsection">
          <img src="../../../../assets/images/why-finzy/flexible-and-transparent.svg"
               alt="Flexible EMI plan"
               class="img-responsive icon">
          <p class="heading">Flexible and Transparent</p>
          <p class="description">At finzy we provide you the benefit of a low monthly EMI, thanks to our flexible 36
            month loan tenure. You can prepay your loan fully or partially whenever you want with no penalties
            incurred.</p>
        </div>

        <div class="col-xs-12 col-md-4 col-lg-4 subsection">
          <img src="../../../../assets/images/why-finzy/credit-assessment.svg"
               alt="Fair credit assessement and evaluation process"
               class="img-responsive icon">
          <p class="heading">Credit Assessment</p>
          <p class="description">Our evaluation process goes beyond the traditional approach of banks. By assessing
            borrowers on multiple parameters and not limited to their credit score, we can offer loans to a much larger
            borrower segment.</p>
        </div>
      </div>
    </div>
  </div>
</section>
